import { Directive, EventEmitter, HostListener, Input, Output, booleanAttribute } from '@angular/core';

@Directive({
  selector: '[libListFilterShortcut]',
  standalone: true,
})
export class ListFilterShortcutDirective {
  @Input({ transform: booleanAttribute }) public libListFilterShortcut = true;

  @Output() public readonly libListFilterShortcutOpen = new EventEmitter<void>();

  @HostListener('document:keydown', ['$event'])
  public onDocumentKeydown(event: KeyboardEvent): void
  {
    if (
      !this.libListFilterShortcut
      || event.defaultPrevented
      || event.altKey
      || event.shiftKey
      || event.isComposing
      || event.key.toLowerCase() !== 'f'
      || (!event.ctrlKey && !event.metaKey)
      || this.isEditableTarget(event.target)
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.libListFilterShortcutOpen.emit();
  }

  private isEditableTarget(target: EventTarget | null): boolean
  {
    const element = target instanceof HTMLElement ? target : null;
    if (!element) {
      return false;
    }

    return Boolean(element.closest('input, textarea, select, [contenteditable="true"], [data-list-filter-shortcut-ignore="true"]'));
  }
}
